(function () {
  var CTA_SELECTOR = '[data-designer-cta]';
  var OPTION_SELECTOR = '[data-single-option-selector]';
  var READY_FLAG = '__pmDesignerCtaReady';
  var productDataCache = {};

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(value);
    }
    return String(value).replace(/["\\]/g, '\\$&');
  }

  function getProductRoot(button) {
    return button.closest('[data-section-type="product"], [data-section-id], [data-product]') || document;
  }

  function parseInlineProductData(root) {
    var script = root.querySelector('[data-product-json]');
    if (!script && root !== document) {
      script = document.querySelector('[data-product-json]');
    }
    if (!script) return null;

    try {
      return JSON.parse(script.textContent || script.innerHTML || '{}');
    } catch (error) {
      return null;
    }
  }

  function getProductData(handle, root) {
    if (!handle) return null;
    if (productDataCache[handle]) return productDataCache[handle];

    var inlineProduct = parseInlineProductData(root);
    if (inlineProduct && inlineProduct.variants) {
      productDataCache[handle] = inlineProduct;
      return productDataCache[handle];
    }

    return null;
  }

  function getOptionCount(productData) {
    if (productData && Array.isArray(productData.options) && productData.options.length) {
      return productData.options.length;
    }

    var firstVariant = productData && Array.isArray(productData.variants)
      ? productData.variants[0]
      : null;

    if (firstVariant && Array.isArray(firstVariant.options)) return firstVariant.options.length;

    var count = 0;
    if (firstVariant && firstVariant.option1) count = 1;
    if (firstVariant && firstVariant.option2) count = 2;
    if (firstVariant && firstVariant.option3) count = 3;
    return count;
  }

  function getVariantOptions(variant) {
    if (!variant) return [];
    if (Array.isArray(variant.options)) return variant.options.map(String);

    return [variant.option1, variant.option2, variant.option3]
      .filter(function (value) {
        return value !== undefined && value !== null;
      })
      .map(String);
  }

  function getSelectedOptionValue(root, optionIndex) {
    var selector = OPTION_SELECTOR + '[data-index="option' + optionIndex + '"]';
    var checked = root.querySelector(selector + ':checked');
    if (checked && checked.value) return checked.value;

    var fields = root.querySelectorAll(selector);
    for (var i = 0; i < fields.length; i += 1) {
      var field = fields[i];
      var type = String(field.type || '').toLowerCase();
      if ((type === 'radio' || type === 'checkbox') && !field.checked) continue;
      if (field.value) return field.value;
    }

    return null;
  }

  function findVariantIdFromOptions(root, productData) {
    if (!productData || !Array.isArray(productData.variants)) return '';

    var optionCount = getOptionCount(productData);
    if (!optionCount) return '';

    var selected = [];
    for (var index = 1; index <= optionCount; index += 1) {
      var selectedValue = getSelectedOptionValue(root, index);
      if (!selectedValue) return '';
      selected.push(String(selectedValue));
    }

    var match = productData.variants.find(function (variant) {
      var options = getVariantOptions(variant);
      if (options.length < selected.length) return false;

      return selected.every(function (selectedValue, idx) {
        return String(options[idx]) === selectedValue;
      });
    });

    return match && match.id ? String(match.id) : '';
  }

  function findProductForm(root) {
    return root.querySelector('form[data-product-form]') ||
      root.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('form[data-product-form]');
  }

  function isUsableVariantInput(input) {
    return input && !input.closest('[data-product-form-installment]');
  }

  function findVariantInput(root) {
    var productForm = findProductForm(root);
    var formId = productForm && productForm.id;
    var candidates = [];

    if (formId) {
      candidates.push('input[name="id"][form="' + cssEscape(formId) + '"]');
    }

    candidates.push(
      '[data-form-wrapper] > input[name="id"][form]',
      '[data-form-wrapper] input[name="id"][form]',
      'form[data-product-form] input[name="id"]',
      'input[name="id"][type="hidden"]'
    );

    for (var i = 0; i < candidates.length; i += 1) {
      var found = root.querySelector(candidates[i]);
      if (isUsableVariantInput(found)) return found;
    }

    return null;
  }

  function buildDesignerUrl(studioUrl, handle, variantId) {
    var url = new URL(studioUrl || '/pages/designer-studio', window.location.origin);
    url.searchParams.set('product', handle);
    if (variantId) url.searchParams.set('variant', variantId);
    return url.pathname + url.search + url.hash;
  }

  function initDesignerButton(button) {
    if (!button || button[READY_FLAG]) return;
    button[READY_FLAG] = true;

    var root = getProductRoot(button);
    var studioUrl = button.getAttribute('data-studio-url') || '/pages/designer-studio';
    var handle = button.getAttribute('data-product-handle') || root.getAttribute('data-product-handle') || '';
    var fallbackVariant = button.getAttribute('data-fallback-variant') || '';
    var eventVariantId = '';

    function resolveVariantId() {
      var productData = getProductData(handle, root);
      var selectedOptionVariant = findVariantIdFromOptions(root, productData);
      if (selectedOptionVariant) return selectedOptionVariant;

      var input = findVariantInput(root);
      if (input && input.value) return String(input.value);

      var urlVariant = new URLSearchParams(window.location.search).get('variant');
      return eventVariantId || urlVariant || fallbackVariant || '';
    }

    function updateHref() {
      var variantId = resolveVariantId();
      var href = buildDesignerUrl(studioUrl, handle, variantId);
      button.setAttribute('href', href);
      return href;
    }

    function handleVariantEvent(event) {
      if (event && event.target && root !== document && !root.contains(event.target)) return;

      var variant = event && event.detail && event.detail.variant;
      eventVariantId = variant && variant.id ? String(variant.id) : '';
      updateHref();
    }

    function queueUpdate() {
      window.requestAnimationFrame(function () {
        updateHref();
      });
    }

    root.addEventListener('theme:variant:change', handleVariantEvent);
    root.addEventListener('variant:change', handleVariantEvent);
    root.addEventListener('change', queueUpdate);
    root.addEventListener('input', queueUpdate);
    root.addEventListener('click', queueUpdate);

    button.addEventListener('click', function (event) {
      event.preventDefault();
      window.location.href = updateHref();
    });

    updateHref();
  }

  function initDesignerCta() {
    document.querySelectorAll(CTA_SELECTOR).forEach(initDesignerButton);
  }

  if (window.theme && typeof window.theme.initProductComponents === 'function') {
    window.theme.initProductComponents();
  }

  ready(initDesignerCta);
})();
